export default __webpack_public_path__ + "static/media/Real-Time Bluedot Wayfinding.774fb3a1.svg";